const LOADING = 'LOADING';
const LOADED = 'LOADED';

const LOGIN_REQUEST = 'LOGIN_REQUEST'
const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
const LOGIN_FAILURE = 'LOGIN_FAILURE'

const LOGOUT = 'LOGOUT';

const SESSIONTIMEOUT = 'SESSIONTIMEOUT';

const DOWNLOADING_NESA_MEMBERSHIP = 'DOWNLOADING_NESA_MEMBERSHIP';
const DOWNLOADED_NESA_MEMBERSHIP = 'DOWNLOADED_NESA_MEMBERSHIP';
const MAXIMUM_CSVRECORDS_REACHED = 'MAXIMUM_CSVRECORDS_REACHED';
const MAXIMUM_CSVRECORDS_REACHED_ClOSE = 'MAXIMUM_CSVRECORDS_REACHED_ClOSE';
// const DOWNLOADED_NESA_PENDING_MEMBERSHIP = 'DOWNLOADED_NESA_PENDING_MEMBERSHIP';
// const DOWNLOADED_NESA_PROCESSED_MEMBERSHIP = 'DOWNLOADED_NESA_PROCESSED_MEMBERSHIP';
// const DOWNLOADED_NESA_DENIED_MEMBERSHIP = 'DOWNLOADED_NESA_DENIED_MEMBERSHIP';


const PROFILE_INFO_LOADING = 'PROFILE_INFO_LOADING';
const PROFILE_INFO = 'PROFILE_INFO';

const QUICK_SEARCH_REQUEST = 'QUICK_SEARCH_REQUEST';
const QUICK_SEARCH_RECORDS = 'QUICK_SEARCH_RECORDS';
const QUICK_SEARCH_RECORDS_ROOT = 'QUICK_SEARCH_RECORDS_ROOT';

const ISADMIN = 'ISADMIN';
const ISADMIN_LOADING = 'ISADMIN_LOADING';

const ISSPECIALIST = 'ISSPECIALIST';
const ISSUPERADMIN = 'ISSUPERADMIN';


const UPDATING_COLUMN = 'UPDATING_COLUMN';
const UPDATED_COLUMN = 'UPDATED_COLUMN';
// const ISADMIN_LOADING = 'ISADMIN_LOADING';

const DOWNLOADING_CSV = 'DOWNLOADING_CSV';
const DOWNLOADED_CSV = 'DOWNLOADED_CSV';
const DOWNLOAD_CSV_ERROR = 'DOWNLOAD_CSV_ERROR';

const PUBLICATIONS = 'PUBLICATIONS';
const PUBLICATIONS_LOADING = 'PUBLICATIONS_LOADING';

const COMPLETE_COLUMN_LIST = 'COMPLETE_COLUMN_LIST'
const COMPLETE_COLUMN_LIST_ERROR = 'COMPLETE_COLUMN_LIST_ERROR'
const COMPLETE_COLUMN_LIST_LOADING = 'COMPLETE_COLUMN_LIST_LOADING'

const MY_PREFERENCE_LIST_LOADING = 'MY_PREFERENCE_LIST_LOADING'
const MY_PREFERENCE_LIST = 'MY_PREFERENCE_LIST'

const PUBLIC_PREFERENCE_LIST_LOADING = 'PUBLIC_PREFERENCE_LIST_LOADING'
const PUBLIC_PREFERENCE_LIST = 'PUBLIC_PREFERENCE_LIST'

const QUICK_PREFERENCE_LIST_LOADING = 'QUICK_PREFERENCE_LIST_LOADING'
const QUICK_PREFERENCE_LIST = 'QUICK_PREFERENCE_LIST'
const REMOVE_QUICK_PREFERENCE_LIST = 'REMOVE_QUICK_PREFERENCE_LIST'

const DASHBOARD_MY_PREFERENCE_LIST_LOADING = 'DASHBOARD_MY_PREFERENCE_LIST_LOADING'
const DASHBOARD_MY_PREFERENCE_LIST = 'DASHBOARD_MY_PREFERENCE_LIST'

const DASHBOARD_QUICK_PREFERENCE_LIST_LOADING = 'DASHBOARD_QUICK_PREFERENCE_LIST_LOADING'
const DASHBOARD_QUICK_PREFERENCE_LIST = 'DASHBOARD_QUICK_PREFERENCE_LIST'

const RUN_PREFERENCE_LIST_LOADING = 'RUN_PREFERENCE_LIST_LOADING'
const RUN_PREFERENCE_LIST = 'RUN_PREFERENCE_LIST'
const RUN_PREFERENCE_LIST_FAILED = 'RUN_PREFERENCE_LIST_FAILED'

const GET_PREFERENCE_DATA = 'GET_PREFERENCE_DATA'
const GET_PREFERENCE_DATA_LOADING = 'GET_PREFERENCE_DATA_LOADING'
const GET_PREFERENCE_DATA_FAILURE = 'GET_PREFERENCE_DATA_FAILURE' 

const CHASE_PAYMENT_LOADING = 'CHASE_PAYMENT_LOADING'
const CHASE_PAYMENT_INIT = 'CHASE_PAYMENT_INIT'

const UPDATE_PROFILE_LOADING = 'UPDATE_PROFILE_LOADING'
const UPDATE_PROFILE = 'UPDATE_PROFILE'

const PERSONS_PROFILE = 'PERSONS_PROFILE'
const PERSONS_PROFILE_LOADING = 'PERSONS_PROFILE_LOADING'

const GET_EVENTS = 'GET_EVENTS'
const GET_EVENTS_LOADING = 'GET_EVENTS_LOADING'

const MEMBERSHIP_VERFICATION_LOADING = 'MEMBERSHIP_VERFICATION_LOADING'
const MEMBERSHIP_VERFICATION_STATUS = 'MEMBERSHIP_VERFICATION_STATUS'

const MEMBERSHIP_RESGISTRATION_LOADING = 'MEMBERSHIP_RESGISTRATION_LOADING'
const MEMBERSHIP_RESGISTRATION = 'MEMBERSHIP_RESGISTRATION'

const SAF_RESGISTRATION_LOADING = 'SAF_RESGISTRATION_LOADING'
const SAF_RESGISTRATION = 'SAF_RESGISTRATION'
const SAF_RESGISTRATION_ERROR = 'SAF_RESGISTRATION_ERROR'

const PURCHASE_RESGISTRATION_LOADING = 'PURCHASE_RESGISTRATION_LOADING'
const PURCHASE_RESGISTRATION = 'PURCHASE_RESGISTRATION'
const PURCHASE_RESGISTRATION_ERROR = 'PURCHASE_RESGISTRATION_ERROR'

const ROLES_LOADING = 'ROLES_LOADING'
const ROLES_RECEIVED = 'ROLES_RECEIVED'

const ETHNICITIES_LOADING = 'ETHNICITIES_LOADING'
const ETHNICITIES_RECEIVED = 'ETHNICITIES_RECEIVED'

const OCCUPATIONS_LOADING = 'OCCUPATIONS_LOADING'
const OCCUPATIONS_RECEIVED = 'OCCUPATIONS_RECEIVED'

const ADDING_OR_REMOVING_HOBBIES = 'ADDING_OR_REMOVING_HOBBIES'
const HOBBIES_ADDED_OR_REMOVED_SUCCESSFULLY = 'HOBBIES_ADDED_OR_REMOVED_SUCCESSFULLY'

const ADDING_OR_REMOVING_BUSINESS = 'ADDING_BUSINESS'
const BUSINESS_ADDED_OR_REMOVED_SUCESSFULLY = 'BUSINESS_ADDED_OR_REMOVED_SUCESSFULLY'

const UPDATING_EMPLOYER_DETAILS = 'UPDATING_EMPLOYER_DETAILS'
const UPDATED_EMPLOYER_DETAILS = 'UPDATED_EMPLOYER_DETAILS'

const DELETING_EMPLOYER_DETAILS = 'DELETING_EMPLOYER_DETAILS'
const DELETED_EMPLOYER_DETAILS = 'DELETED_EMPLOYER_DETAILS'

const DELETING_OCCUPATION_DETAILS = 'DELETING_OCCUPATION_DETAILS'
const DELETED_OCCUPATION_DETAILS = 'DELETED_OCCUPATION_DETAILS'

const PENDING_MEMBERSHIP_LOADING = 'PENDING_MEMBERSHIP_LOADING'
const PENDING_MEMBERSHIP_RECEIVED = 'PENDING_MEMBERSHIP_RECEIVED'

const PROCESSED_MEMBERSHIP_LOADING = 'PROCESSED_MEMBERSHIP_LOADING'
const PROCESSED_MEMBERSHIP_RECEIVED = 'PROCESSED_MEMBERSHIP_RECEIVED'

const DENIED_MEMBERSHIP_LOADING = 'DENIED_MEMBERSHIP_LOADING'
const DENIED_MEMBERSHIP_RECEIVED = 'DENIED_MEMBERSHIP_RECEIVED'

const MEMBERSHIP_RECORD_LOADING = 'MEMBERSHIP_RECORD_LOADING'
const MEMBERSHIP_RECORD_RECEIVED = 'MEMBERSHIP_RECORD_RECEIVED'
const MEMBERSHIP_RECORD_FAILURE = 'MEMBERSHIP_RECORD_FAILURE'

const MEMBERSHIP_RECORD_PAYMENT_LOADING = 'MEMBERSHIP_RECORD_PAYMENT_LOADING'
const MEMBERSHIP_RECORD_PAYMENT_RECEIVED = 'MEMBERSHIP_RECORD_PAYMENT_RECEIVED'

const COUNTRIES_LOADING = 'COUNTRIES_LOADING'
const COUNTRIES_RECEIVED = 'COUNTRIES_RECEIVED'
const COUNTRIES_FAILED = 'COUNTRIES_FAILED'

const PHONE_COUNTRY_CODE_LOADING = 'PHONE_COUNTRY_CODE_LOADING'
const PHONE_COUNTRY_CODE = 'PHONE_COUNTRY_CODE'
const PHONE_COUNTRY_CODE_FAILED = 'PHONE_COUNTRY_CODE_FAILED'

const STATES_LOADING = 'STATES_LOADING'
const STATES_RECEIVED = 'STATES_RECEIVED'
const STATES_FAILED = 'STATES_FAILED'

const NESA_LEVELS_LOADING = 'NESA_LEVELS_LOADING'
const NESA_LEVELS_RECEIVED = 'NESA_LEVELS_RECEIVED'
const NESA_LEVELS_FAILED = 'NESA_LEVELS_FAILED'

const PRODUCT_PRICING_LOADING = 'PRODUCT_PRICING_LOADING'
const PRODUCT_PRICING_RECEIVED = 'PRODUCT_PRICING_RECEIVED'
const PRODUCT_PRICING_FAILED = 'PRODUCT_PRICING_FAILED'

const MY_EAGLE_INFO_LOADING = 'MY_EAGLE_INFO_LOADING'
const MY_EAGLE_INFO_RECEIVED = 'MY_EAGLE_INFO_RECEIVED'

const SAF_LEVELS_LOADING = 'SAF_LEVELS_LOADING'
const SAF_LEVELS_RECEIVED = 'SAF_LEVELS_RECEIVED'

const UPDATING_ADDRESS = 'UPDATING_ADDRESS'
const ADDRESS_UPDATED = 'ADDRESS_UPDATED'

const ADVANCED_SEARCH_LIST_LOADING = 'ADVANCED_SEARCH_LIST_LOADING'
const ADVANCED_SEARCH_LIST = 'ADVANCED_SEARCH_LIST'
const REMOVE_ADVANCED_SEARCH_LIST = 'REMOVE_ADVANCED_SEARCH_LIST'
const ADVANCED_SEARCH_LIST_FAILED = 'ADVANCED_SEARCH_LIST_FAILED'


const ACTIVATE_MEMBERSHIP_STATUS_LOADING = 'ACTIVATE_MEMBERSHIP_STATUS_LOADING'
const ACTIVATE_MEMBERSHIP_STATUS = 'ACTIVATE_MEMBERSHIP_STATUS'

const PENDING_MEMBERSHIP_APPLICATION_STATUS_LOADING = 'PENDING_MEMBERSHIP_APPLICATION_STATUS_LOADING'
const PENDING_MEMBERSHIP_APPLICATION_STATUS = 'PENDING_MEMBERSHIP_APPLICATION_STATUS'

const DENY_MEMBERSHIP_APPLICATION_STATUS_LOADING = 'DENY_MEMBERSHIP_APPLICATION_STATUS_LOADING'
const DENY_MEMBERSHIP_APPLICATION_STATUS = 'DENY_MEMBERSHIP_APPLICATION_STATUS'

const DENY_TO_PENDING_MEMBERSHIP_APPLICATION_STATUS_LOADING = 'DENY_TO_PENDING_MEMBERSHIP_APPLICATION_STATUS_LOADING'
const DENY_TO_PENDING_MEMBERSHIP_APPLICATION_STATUS = 'DENY_TO_PENDING_MEMBERSHIP_APPLICATION_STATUS'

const PAYMENT_COMPLETED = 'PAYMENT_COMPLETED'

const SEARCH_PENDING_MEMBERSHIP = 'SEARCH_PENDING_MEMBERSHIP'

const GIFT_MEMBERSHIP_RESGISTRATION_LOADING = 'GIFT_MEMBERSHIP_RESGISTRATION_LOADING'
const GIFT_MEMBERSHIP_RESGISTRATION = 'GIFT_MEMBERSHIP_RESGISTRATION'
const GIFT_MEMBERSHIP_RESGISTRATION_ERROR = 'GIFT_MEMBERSHIP_RESGISTRATION_ERROR'

const ADD_MEMBERSHIP_RESGISTRATION_LOADING = 'ADD_MEMBERSHIP_RESGISTRATION_LOADING'
const ADD_MEMBERSHIP_RESGISTRATION = 'ADD_MEMBERSHIP_RESGISTRATION'
const ADD_MEMBERSHIP_RESGISTRATION_ERROR = 'ADD_MEMBERSHIP_RESGISTRATION_ERROR'

const CASH_PAYMENT_INITIATED = 'CASH_PAYMENT_INITIATED'
const CASH_PAYMENT_COMPLETED = 'CASH_PAYMENT_COMPLETED'

const ALUMNI_INFO = 'ALUMNI_INFO'
const ALUMNI_INFO_LOADING = 'ALUMNI_INFO_LOADING'

const ALUMNI_EAGLE_INFO_LOADING = 'ALUMNI_EAGLE_INFO_LOADING'
const ALUMNI_EAGLE_INFO_RECEIVED = 'ALUMNI_EAGLE_INFO_RECEIVED'

const NESA_REGISTRATION_LOADING = 'NESA_REGISTRATION_LOADING'
const NESA_REGISTRATION_RECEIVED = 'NESA_REGISTRATION_RECEIVED'

const NESA_NON_REVENUE_MEMBERSHIP_ADDING = 'NESA_NON_REVENUE_MEMBERSHIP_ADDING'
const NESA_NON_REVENUE_MEMBERSHIP_ADDED = 'NESA_NON_REVENUE_MEMBERSHIP_ADDED'
const NESA_NON_REVENUE_MEMBERSHIP_ADD_FAILED = 'NESA_NON_REVENUE_MEMBERSHIP_ADD_FAILED'

const SAF_REGISTRATION_LOADING = 'SAF_REGISTRATION_LOADING'
const SAF_REGISTRATION_RECEIVED = 'SAF_REGISTRATION_RECEIVED'

const PROFILE_PICTURE_UPDATING = 'PROFILE_PICTURE_UPDATING'
const PROFILE_PICTURE_UPDATED = 'PROFILE_PICTURE_UPDATED'

const MARITAL_STATUS_LOADING = 'MARITAL_STATUS_LOADING'
const MARITAL_STATUS_LOADED = 'MARITAL_STATUS_LOADED'

const MY_RANKS_LOADING = 'MY_RANKS_LOADING'
const MY_RANKS_LOADED = 'MY_RANKS_LOADED'

const ALL_RANKS_LOADING = 'ALL_RANKS_LOADING'
const ALL_RANKS_LOADED = 'ALL_RANKS_LOADED'

const ADDRESS_TYPES_LOADING = 'ADDRESS_TYPES_LOADING'
const ADDRESS_TYPES_LOADED = 'ADDRESS_TYPES_LOADED'

const COMMUNICATION_TYPES_LOADING = 'COMMUNICATION_TYPES_LOADING'
const COMMUNICATION_TYPES_LOADED = 'COMMUNICATION_TYPES_LOADED'

const MY_ADDRESS_UPDATING = 'MY_ADDRESS_UPDATING'
const MY_ADDRESS_UPDATED = 'MY_ADDRESS_UPDATED'
const MY_ADDRESS_UPDATE_FAILED = 'MY_ADDRESS_UPDATE_FAILED'

const PRIVACY_SETTINGS_LOADING = 'PRIVACY_SETTINGS_LOADING'
const PRIVACY_SETTINGS_UPDATED = 'PRIVACY_SETTINGS_UPDATED'

const GENDERS_LOADING = 'GENDERS_LOADING'
const GENDERS_RECEIVED = 'GENDERS_RECEIVED'

const PREFIX_LOADING = 'PREFIX_LOADING'
const PREFIX_RECEIVED = 'PREFIX_RECEIVED'
const SUFFIX_LOADING = 'SUFFIX_LOADING'
const SUFFIX_RECEIVED = 'SUFFIX_RECEIVED'

const ALUMNI_INFORMATION_UPDATING = 'ALUMNI_INFORMATION_UPDATING'
const ALUMNI_INFORMATION_UPDATED = 'ALUMNI_INFORMATION_UPDATED'
const ALUMNI_INFORMATION_UPDATE_FAILED = 'ALUMNI_INFORMATION_UPDATE_FAILED'

const ALUMNI_INFORMATION_UPDATING_BY_ADMIN = 'ALUMNI_INFORMATION_UPDATING_BY_ADMIN'
const ALUMNI_INFORMATION_UPDATED_BY_ADMIN = 'ALUMNI_INFORMATION_UPDATED_BY_ADMIN'
const ALUMNI_INFORMATION_UPDATE_FAILED_BY_ADMIN = 'ALUMNI_INFORMATION_UPDATE_FAILED_BY_ADMIN'

const ADDITIONAL_INFORMATION_UPDATING = 'ADDITIONAL_INFORMATION_UPDATING'
const ADDITIONAL_INFORMATION_UPDATED = 'ADDITIONAL_INFORMATION_UPDATED'

const HOME_ADDRESS_LOADING = 'HOME_ADDRESS_LOADING'
const HOME_ADDRESS_RECEIVED = 'HOME_ADDRESS_RECEIVED'

const MY_CONTACT_INFORMATION_UPDATING = 'MY_CONTACT_INFORMATION_UPDATING'
const MY_CONTACT_INFORMATION_UPDATED = 'MY_CONTACT_INFORMATION_UPDATED'
const MY_CONTACT_INFORMATION_UPDATE_FAILED = 'MY_CONTACT_INFORMATION_UPDATE_FAILED'

const RECEIVE_NOTES = 'RECEIVE_NOTES'

const SAF_MEMBERSHIP_UPDATING = 'SAF_MEMBERSHIP_UPDATING'
const SAF_MEMBERSHIP_UPDATED = 'SAF_MEMBERSHIP_UPDATED'
const SAF_MEMBERSHIP_UPDATE_FAILED = 'SAF_MEMBERSHIP_UPDATE_FAILED'

const NESA_MEMBERSHIP_UPDATING = 'NESA_MEMBERSHIP_UPDATING'
const NESA_MEMBERSHIP_UPDATED = 'NESA_MEMBERSHIP_UPDATED'
const NESA_MEMBERSHIP_UPDATE_FAILED = 'NESA_MEMBERSHIP_UPDATE_FAILED'

const MEMBERSHIP_NOTES_UPDATING = 'MEMBERSHIP_NOTES_UPDATING'
const MEMBERSHIP_NOTES_UPDATED = 'MEMBERSHIP_NOTES_UPDATED'

const LOADING_RECEIPT = 'LOADING_RECEIPT'
const LOADED_RECEIPT = 'LOADED_RECEIPT'

const ALUMNI_ADDRESS_UPDATING = 'ALUMNI_ADDRESS_UPDATING'
const ALUMNI_ADDRESS_UPDATED = 'ALUMNI_ADDRESS_UPDATED'
const ALUMNI_ADDRESS_UPDATE_FAILED = 'ALUMNI_ADDRESS_UPDATE_FAILED'

const ALUMNI_CONTACT_INFORMATION_UPDATING = 'ALUMNI_CONTACT_INFORMATION_UPDATING'
const ALUMNI_CONTACT_INFORMATION_UPDATED = 'ALUMNI_CONTACT_INFORMATION_UPDATED'
const ALUMNI_CONTACT_INFORMATION_UPDATE_FAILED = 'ALUMNI_CONTACT_INFORMATION_UPDATE_FAILED'

const LOOKUP_SOCIALMEDIA_LOADING = 'LOOKUP_SOCIALMEDIA_LOADING'
const LOOKUP_SOCIALMEDIA_RECEIVED = 'LOOKUP_SOCIALMEDIA_RECEIVED'

const REQUESTING_REG_STATUS = 'REQUESTING_REG_STATUS'
const RECEIVING_REG_STATUS = 'RECEIVING_REG_STATUS'
const REG_STATUS_FAILED = 'REG_STATUS_FAILED'

const WEB_CONTACT_INFORMATION_UPDATING = 'WEB_CONTACT_INFORMATION_UPDATING'
const WEB_CONTACT_INFORMATION_UPDATED = 'WEB_CONTACT_INFORMATION_UPDATED'

const ACCEPTING_TOC = 'ACCEPTING_TOC'
const ACCEPTED_TOC = 'ACCEPTED_TOC'

const GETTING_ALUMNI_SUMMARY = 'GETTING_ALUMNI_SUMMARY'
const GET_ALUMNI_SUMMARY = 'GET_ALUMNI_SUMMARY'

const GETTING_ALUMNI_SUMMARY_BTW = 'GETTING_ALUMNI_SUMMARY_BTW'
const GET_ALUMNI_SUMMARY_BTW = 'GET_ALUMNI_SUMMARY_BTW'

const GETTING_EAGLE_SCOUTS_SUMMARY = 'GETTING_EAGLE_SCOUTS_SUMMARY'
const GET_EAGLE_SCOUTS_SUMMARY = 'GET_EAGLE_SCOUTS_SUMMARY'

const GETTING_EAGLE_SCOUTS_SUMMARY_CUSTOMDATE = 'GETTING_EAGLE_SCOUTS_SUMMARY_CUSTOMDATE'
const GET_EAGLE_SCOUTS_SUMMARY_CUSTOMDATE = 'GET_EAGLE_SCOUTS_SUMMARY_CUSTOMDATE'

const GETTING_NESA_SUMMARY = 'GETTING_NESA_SUMMARY'
const GET_NESA_SUMMARY = 'GET_NESA_SUMMARY'

const GETTING_NESA_SUMMARY_CUSTOMDATE = 'GETTING_NESA_SUMMARY_CUSTOMDATE'
const GET_NESA_SUMMARY_CUSTOMDATE = 'GET_NESA_SUMMARY_CUSTOMDATE'

const REQUESTED_TO_GET_ALUMNI_AND_LOCAL_AWARDS = 'REQUESTED_TO_GET_ALUMNI_AND_LOCAL_AWARDS'
const RECEIVED_ALUMNI_AND_LOCAL_AWARDS = 'RECEIVED_ALUMNI_AND_LOCAL_AWARDS'
const FAILED_TO_GET_ALUMNI_AND_LOCAL_AWARDS = 'FAILED_TO_GET_ALUMNI_AND_LOCAL_AWARDS'

const REQUESTED_TO_GET_RANKS_BY_USERNAME = 'REQUESTED_TO_GET_RANKS_BY_USERNAME'
const RECEIVED_RANKS_BY_USERNAME = 'RECEIVED_RANKS_BY_USERNAME'
const FAILED_TO_GET_RANKS_BY_USERNAME = 'FAILED_TO_GET_RANKS_BY_USERNAME'

const REQUESTED_TO_GET_SCOUTINGS_AFFILIATIONS = 'REQUESTED_TO_GET_SCOUTINGS_AFFILIATIONS'
const RECEIVED_SCOUTINGS_AFFILIATIONS = 'RECEIVED_SCOUTINGS_AFFILIATIONS'
const FAILED_TO_GET_SCOUTINGS_AFFILIATIONS = 'FAILED_TO_GET_SCOUTINGS_AFFILIATIONS'

const REQUESTED_TO_GET_COUNCIL_AFFILIATIONS = 'REQUESTED_TO_GET_COUNCIL_AFFILIATIONS'
const RECEIVED_COUNCIL_AFFILIATIONS = 'RECEIVED_COUNCIL_AFFILIATIONS'
const FAILED_TO_GET_COUNCIL_AFFILIATIONS = 'FAILED_TO_GET_COUNCIL_AFFILIATIONS'

const REQUESTED_TO_GET_AFFINITIES = 'REQUESTED_TO_GET_AFFINITIES'
const RECEIVED_AFFINITIES = 'RECEIVED_AFFINITIES'
const FAILED_TO_GET_AFFINITIES = 'FAILED_TO_GET_AFFINITIES'

const REQUESTED_TO_GET_COUNCIL_BY_ZIPCODE = 'REQUESTED_TO_GET_COUNCIL_BY_ZIPCODE'
const RECEIVED_COUNCIL_BY_ZIPCODE = 'RECEIVED_COUNCIL_BY_ZIPCODE'
const FAILED_TO_GET_COUNCIL_BY_ZIPCODE = 'FAILED_TO_GET_COUNCIL_BY_ZIPCODE'


const LOADING_AWARDS = 'LOADING_AWARDS'
const LOADED_AWARDS = 'LOADED_AWARDS'

const LOADING_ALUMNI_AWARDS = 'LOADING_ALUMNI_AWARDS'
const LOADED_ALUMNI_AWARDS = 'LOADED_ALUMNI_AWARDS'

const LOADING_SCOUTINGS = 'LOADING_SCOUTINGS'
const LOADED_SCOUTINGS = 'LOADED_SCOUTINGS'

const LOADING_AFFINITIES = 'LOADING_AFFINITIES'
const LOADED_AFFINITIES = 'LOADED_AFFINITIES'

const LOADING_LOCALAWARDS = 'LOADING_LOCALAWARDS'
const LOADED_LOCALAWARDS = 'LOADED_LOCALAWARDS'

const ADD_LOCALAWARDS = 'ADD_LOCALAWARDS'
const ADDED_LOCALAWARDS = 'ADDED_LOCALAWARDS'

const ADD_NEW_EAGLE_DETAILS = 'ADD_NEW_EAGLE_DETAILS'
const ADDED_NEW_EAGLE_DETAILS = 'ADDED_NEW_EAGLE_DETAILS'
const FAILED_NEW_EAGLE_DETAILS = 'FAILED_NEW_EAGLE_DETAILS'

const ADD_ADMINREPAIR = 'ADD_ADMINREPAIR'
const ADDED_ADMINREPAIR = 'ADDED_ADMINREPAIR'
const ADD_ADMINREPAIR_FAILED = 'ADD_ADMINREPAIR_FAILED'

const DELETE_LOCALAWARDS = 'DELETE_LOCALAWARDS'
const DELETED_LOCALAWARDS = 'DELETED_LOCALAWARDS'

const DELETE_SCOUTINGS = 'DELETE_SCOUTINGS'
const DELETED_SCOUTINGS = 'DELETED_SCOUTINGS'

const DELETE_COUNCILS = 'DELETE_COUNCILS'
const DELETED_COUNCILS = 'DELETED_COUNCILS'

const ADD_SCOUTING = 'ADD_SCOUTING'
const ADDED_SCOUTING = 'ADDED_SCOUTING'

const ADD_AFFINITIES = 'ADD_AFFINITIES'
const ADDED_AFFINITIES = 'ADDED_AFFINITIES'

const DELETE_AFFINITIES = 'DELETE_AFFINITIES'
const DELETED_AFFINITIES = 'DELETED_AFFINITIES'

const LOADING_COUNCILS = 'LOADING_COUNCILS'
const LOADED_COUNCILS = 'LOADED_COUNCILS'

const LOADING_ORGANIZATION_COUNCILS = 'LOADING_ORGANIZATION_COUNCILS'
const LOADED_ORGANIZATION_COUNCILS = 'LOADED_ORGANIZATION_COUNCILS'

const LOADING_NATIONAL_AWARDS = 'LOADING_NATIONAL_AWARDS'
const LOADED_NATIONAL_AWARDS = 'LOADED_NATIONAL_AWARDS'


const ADD_COUNCILS = 'ADD_COUNCILS'
const ADDED_COUNCILS = 'ADDED_COUNCILS'

const REDIRECTING = 'REDIRECTING'
const REDIRECTED = 'REDIRECTED'

const MEMBERID_LOADING = 'MEMBERID_LOADING'
const MEMBERID_LOADED = 'MEMBERID_LOADED'

const ADDING_MEMBERID = 'ADDING_MEMBERID'
const ADDED_MEMBERID = 'ADDED_MEMBERID'
const FAILED_TO_ADD_MEMBERID = 'FAILED_TO_ADD_MEMBERID'

const DELETING_MEMBERID = 'DELETING_MEMBERID'
const DELETED_MEMBERID = 'DELETED_MEMBERID'
const FAILED_TO_DELETE_MEMBERID = 'FAILED_TO_DELETE_MEMBERID'

const MEMBERID_UPDATING = 'MEMBERID_UPDATING'
const MEMBERID_UPDATED = 'MEMBERID_UPDATED'

const LOADING_COM_PREFER = 'LOADING_COM_PREFER'
const COM_PREFER = 'COM_PREFER'

const UPDATING_COM_PREFER = 'UPDATING_COM_PREFER'

const SEARCHING_EAGLE = 'SEARCHING_EAGLE'
const SEARCHED_EAGLE = 'SEARCHED_EAGLE'

const SENDING_SPARK_OPPORTUNITY_FORM = 'SENDING_SPARK_OPPORTUNITY_FORM'
const SUCCESSFULLY_SENT_SPARK_OPPORTUNITY_FORM = 'SUCCESSFULLY_SENT_SPARK_OPPORTUNITY_FORM'
const FAILED_TO_SENT_SPARK_OPPORTUNITY_FORM = 'FAILED_TO_SENT_SPARK_OPPORTUNITY_FORM'
const PROMOCODE_LOADING = 'PROMOCODE_LOADING'
const PROMOCODE_ERROR = 'PROMOCODE_ERROR'
const PROMOCODE_APPLIED = 'PROMOCODE_APPLIED'

const REMOVE_PROMOCODE_LOADING = 'REMOVE_PROMOCODE_LOADING'
const REMOVE_PROMOCODE_ERROR = 'REMOVE_PROMOCODE_ERROR'
const PROMOCODE_REMOVED = 'PROMOCODE_REMOVED'

const SEARCH_PROMOCODE_LOADING = 'SEARCH_PROMOCODE_LOADING'
const GET_PROMOCODE_LOADING = 'GET_PROMOCODE_LOADING'
const GOT_PROMOCODE_SUCCESSFULLY = 'GOT_PROMOCODE_SUCCESSFULLY'
const GET_PROMOCODE_ERROR = 'GET_PROMOCODE_ERROR'

const ADD_PROMOCODE_LOADING = 'ADD_PROMOCODE_LOADING'
const ADDED_PROMOCODE_SUCCESSFULLY = 'ADDED_PROMOCODE_SUCCESSFULLY'
const ADD_PROMOCODE_ERROR = 'ADD_PROMOCODE_ERROR'

const UPDATE_PROMOCODE_LOADING = 'UPDATE_PROMOCODE_LOADING'
const UPDATED_PROMOCODE_SUCCESSFULLY = 'UPDATED_PROMOCODE_SUCCESSFULLY'
const UPDATE_PROMOCODE_ERROR = 'UPDATE_PROMOCODE_ERROR'

const DELETE_PROMOCODE_LOADING = 'DELETE_PROMOCODE_LOADING'
const DELETED_PROMOCODE_SUCCESSFULLY = 'DELETED_PROMOCODE_SUCCESSFULLY'
const DELETE_PROMOCODE_ERROR = 'DELETE_PROMOCODE_ERROR'

const GETTING_ORDER_SOURCE = 'GETTING_ORDER_SOURCE'
const GOT_ORDER_SOURCE_SUCCESSFULLY = 'GOT_ORDER_SOURCE_SUCCESSFULLY'
const ORDER_SOURCE_FAILED = 'ORDER_SOURCE_FAILED'

const GETTING_BSA_ORDER_TYPE = 'GETTING_BSA_ORDER_TYPE'
const GOT_BSA_ORDER_TYPE_SUCCESSFULLY = 'GOT_BSA_ORDER_TYPE_SUCCESSFULLY'
const BSA_ORDER_TYPE_FAILED = 'BSA_ORDER_TYPE_FAILED'

const PAYMENTS_CREATING = 'PAYMENTS_CREATING'
const PAYMENTS_CREATED = 'PAYMENTS_CREATED'

const GETTING_SHOPPINGCART = 'GETTING_SHOPPINGCART'
const RECIVED_SHOPPINGCART = 'RECIVED_SHOPPINGCART'

const BULK_UPLOADING = 'BULK_UPLOADING'
const BULK_UPLOADED = 'BULK_UPLOADED'

const ALUMNI_BULK_UPLOADING = 'ALUMNI_BULK_UPLOADING'
const ALUMNI_BULK_UPLOADED = 'ALUMNI_BULK_UPLOADED'
const ALUMNI_BULK_UPLOAD_ERROR = 'ALUMNI_BULK_UPLOAD_ERROR'

const REQ_TO_EXPIRE_MEMBERSHIP = 'REQ_TO_EXPIRE_MEMBERSHIP'
const RES_OF_EXPIRE_MEMBERSHIP = 'RES_OF_EXPIRE_MEMBERSHIP'

const REQUESTING_ALUMNI_PRIVACY_OPTIONS = 'REQUESTING_ALUMNI_PRIVACY_OPTIONS'
const RECEIVED_ALUMNI_PRIVACY_OPTIONS = 'RECEIVED_ALUMNI_PRIVACY_OPTIONS'
const FAILED_TO_GET_ALUMNI_PRIVACY_OPTIONS = 'FAILED_TO_GET_ALUMNI_PRIVACY_OPTIONS'

const UPDATING_ALUMNI_PRIVACY_OPTIONS = 'UPDATING_ALUMNI_PRIVACY_OPTIONS'
const UPDATED_ALUMNI_PRIVACY_OPTIONS = 'UPDATED_ALUMNI_PRIVACY_OPTIONS'
const FAILED_TO_UPDATE_ALUMNI_PRIVACY_OPTIONS = 'FAILED_TO_UPDATE_ALUMNI_PRIVACY_OPTIONS'

const EAGLE_NESA_MEMBERSHIPS_LOADING = 'EAGLE_NESA_MEMBERSHIPS_LOADING'
const EAGLE_NESA_MEMBERSHIPS_RECEIVED = 'EAGLE_NESA_MEMBERSHIPS_RECEIVED'
const EAGLE_NESA_MEMBERSHIPS_ERROR = 'EAGLE_NESA_MEMBERSHIPS_ERROR'

const ASSIGN_ROLES_POSITIONS_LOADING = 'ASSIGN_ROLES_POSITIONS_LOADING'
const ASSIGN_ROLES_POSITIONS = 'ASSIGN_ROLES_POSITIONS'
const ASSIGN_ROLES_POSITIONS_ERROR = 'ASSIGN_ROLES_POSITIONS_ERROR'

const USER_FUNCTIONAL_ROLES_LOADING = 'USER_FUNCTIONAL_ROLES_LOADING'
const USER_FUNCTIONAL_ROLES_RECEIVED = 'USER_FUNCTIONAL_ROLES_RECEIVED'
const USER_FUNCTIONAL_ROLES_ERROR = 'USER_FUNCTIONAL_ROLES_ERROR'

const REMOVE_USER_ROLE_LOADING = 'REMOVE_USER_ROLE_LOADING'
const REMOVE_USER_ROLE_SUCCESS = 'REMOVE_USER_ROLE_SUCCESS'
const REMOVE_USER_ROLE_ERROR = 'REMOVE_USER_ROLE_ERROR'

const SEARCHING_GLOBAL = 'SEARCHING_GLOBAL'
const SEARCHED_GLOBAL = 'SEARCHED_GLOBAL'
const SEARCHED_GLOBAL_ERROR = 'SEARCHED_GLOBAL_ERROR'

const ROLES_PERSONSGUID_LOADING = 'ROLES_PERSONSGUID_LOADING'
const ROLES_PERSONSGUID_RECEIVE = 'ROLES_PERSONSGUID_RECEIVE'
const ROLES_PERSONSGUID_ERROR = 'ROLES_PERSONSGUID_ERROR'

const GETTING_ACTIVE_REGISTRATIONS_FOR_EXTEND_ROLE = 'GETTING_ACTIVE_REGISTRATIONS_FOR_EXTEND_ROLE'
const RECEIVED_ACTIVE_REGISTRATIONS_FOR_EXTEND_ROLE = 'RECEIVED_ACTIVE_REGISTRATIONS_FOR_EXTEND_ROLE'
const FAILED_ACTIVE_REGISTRATIONS_FOR_EXTEND_ROLE = 'FAILED_ACTIVE_REGISTRATIONS_FOR_EXTEND_ROLE'

const GET_COUNCILS_LOADING = 'GET_COUNCILS_LOADING'
const GET_COUNCILS_RECEIVE = 'GET_COUNCILS_RECEIVE'
const GET_COUNCILS_ERROR = 'GET_COUNCILS_ERROR'

const GET_POSITIONS_LOADING = 'GET_POSITIONS_LOADING'
const GET_POSTIONS_RECEIVE = 'GET_POSTIONS_RECEIVE'
const GET_POSTIONS_ERROR = 'GET_POSTIONS_ERROR'

const SUPER_ADMIN_LOADING = 'SUPER_ADMIN_LOADING'
const SUPER_ADMIN_RECEIVE = 'SUPER_ADMIN_RECEIVE'
const CHILD_ORG_LOADING = 'CHILD_ORG_LOADING'
const CHILD_ORG_RECEIVE = 'CHILD_ORG_RECEIVE'
const CHILD_ORG_ERROR = 'CHILD_ORG_ERROR'

const ORGANIZATION_POSITIONS_LOADING = "ORGANIZATION_POSITIONS_LOADING"
const ORGANIZATION_POSITIONS_RECEIVE = "ORGANIZATION_POSITIONS_RECEIVE"
const ORGANIZATION_POSITIONS_ERROR = "ORGANIZATION_POSITIONS_ERROR"

const ROLES_EXPIRE_LOADING = "ROLES_EXPIRE_LOADING"
const ROLES_EXPIRE_SUCCESS = "ROLES_EXPIRE_SUCCESS"
const ROLES_EXPIRE_ERROR = "ROLES_EXPIRE_ERROR"

// const RECORDS_LOADING_START = "RECORDS_LOADING_START";
// const RECORDS_LOADING_STOP = "RECORDS_LOADING_STOP";

const ADVANCED_RECORDS_LOADING_START = "ADVANCED_RECORDS_LOADING_START";
const ADVANCED_RECORDS_LOADING_STOP = "ADVANCED_RECORDS_LOADING_STOP";

const ALUMNI_RECORDS_LOADING_START = "ALUMNI_RECORDS_LOADING_START"
const ALUMNI_RECORDS_LOADING_STOP = "ALUMNI_RECORDS_LOADING_STOP"

const QUICK_RECORDS_LOADING_START = "QUICK_RECORDS_LOADING_START"
const QUICK_RECORDS_LOADING_STOP = "QUICK_RECORDS_LOADING_STOP"

const SHOW_ABOUT_TO_EXPIRE = "SHOW_ABOUT_TO_EXPIRE"
const HIDE_ABOUT_TO_EXPIRE = "HIDE_ABOUT_TO_EXPIRE"

const GET_RANKS_LOADING = "GET_RANKS_LOADING"
const GET_RANKS_RECEIVE = "GET_RANKS_RECEIVE"
const GET_RANKS_ERROR = "GET_RANKS_ERROR"

const UPDATE_RANK_LOADING = "UPDATE_RANK_LOADING"
const UPDATE_RANK_SUCCESS = "UPDATE_RANK_SUCCESS"
const UPDATE_RANK_ERROR = "UPDATE_RANK_ERROR"

const DELETE_RANK_LOADING = "DELETE_RANK_LOADING"
const DELETE_RANK_SUCCESS = "DELETE_RANK_SUCCESS"
const DELETE_RANK_ERROR = "DELETE_RANK_ERROR"

const GET_LOOKUPS_RANKS_LOADING = "GET_LOOKUPS_RANKS_LOADING"
const GET_LOOKUPS__RANKS_RECEIVE = "GET_LOOKUPS__RANKS_RECEIVE"
const GET_LOOKUPS_RANKS_ERROR = "GET_LOOKUPS_RANKS_ERROR"

const ADD_PERSON_REQUEST = "ADD_PERSON_REQUEST"
const ADD_PERSON_SUCCESS = "ADD_PERSON_SUCCESS"
const ADD_PERSON_ERROR = "ADD_PERSON_ERROR"

const GET_COMMUNITY_LOADING = "GET_COMMUNITY_LOADING"
const GET_COMMUNITY_RECEIVE = "GET_COMMUNITY_RECEIVE"
const GET_COMMUNITY_ERROR = "GET_COMMUNITY_ERROR"

const ALUMNI_LOOKUP_LOADING = "ALUMNI_LOOKUP_LOADING";
const ALUMNI_LOOKUP_SUCCESS = "ALUMNI_LOOKUP_SUCCESS";
const ALUMNI_LOOKUP_ERROR = "ALUMNI_LOOKUP_ERROR";
const GET_COMMUNITY_LOOKUP_LOADING = "GET_COMMUNITY_LOOKUP_LOADING";
const GET_COMMUNITY_LOOKUP_SUCCESS = "GET_COMMUNITY_LOOKUP_SUCCESS";
const GET_COMMUNITY_LOOKUP_ERROR   = "GET_COMMUNITY_LOOKUP_ERROR";
const FAILED_TO_GET_COMMUNITY_ERROR = "FAILED_TO_GET_COMMUNITY_ERROR"

const REQ_TO_GET_REPORT_COLUMN = "REQ_TO_GET_REPORT_COLUMN"
const RECEIVED_GET_REPORT_COLUMN = "RECEIVED_GET_REPORT_COLUMN"


module.exports = {
    SUPER_ADMIN_RECEIVE, SUPER_ADMIN_LOADING, GET_POSTIONS_ERROR, GET_POSTIONS_RECEIVE, GET_POSITIONS_LOADING, GET_COUNCILS_ERROR, GET_COUNCILS_RECEIVE, GET_COUNCILS_LOADING, ALUMNI_BULK_UPLOADED, ALUMNI_BULK_UPLOAD_ERROR, ALUMNI_BULK_UPLOADING, BULK_UPLOADED, BULK_UPLOADING, DENIED_MEMBERSHIP_RECEIVED, DENIED_MEMBERSHIP_LOADING, SEARCHED_EAGLE, SEARCHING_EAGLE, PROCESSED_MEMBERSHIP_LOADING, PROCESSED_MEMBERSHIP_RECEIVED, COM_PREFER, LOADING_COM_PREFER, UPDATING_COM_PREFER, MEMBERID_UPDATED, MEMBERID_UPDATING, MEMBERID_LOADED, MEMBERID_LOADING, REDIRECTING, REDIRECTED, DELETED_COUNCILS, DELETE_COUNCILS, ADD_COUNCILS, ADDED_COUNCILS, LOADING_COUNCILS, LOADED_COUNCILS, LOADING_ORGANIZATION_COUNCILS, LOADED_ORGANIZATION_COUNCILS, ADD_SCOUTING, ADDED_SCOUTING, DELETE_SCOUTINGS, DELETED_SCOUTINGS, LOADING_ALUMNI_AWARDS, LOADED_ALUMNI_AWARDS, LOADING_SCOUTINGS, LOADED_SCOUTINGS, LOADING_AFFINITIES, LOADED_AFFINITIES, LOADING_AWARDS, LOADED_AWARDS, GET_ALUMNI_SUMMARY_BTW, GETTING_ALUMNI_SUMMARY_BTW, GET_ALUMNI_SUMMARY, GETTING_ALUMNI_SUMMARY, ACCEPTED_TOC, ACCEPTING_TOC, LOADING, LOADED, SEARCH_PENDING_MEMBERSHIP, PROFILE_PICTURE_UPDATING, PROFILE_PICTURE_UPDATED, COMMUNICATION_TYPES_LOADED, COMMUNICATION_TYPES_LOADING,
    LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT, SESSIONTIMEOUT, ALL_RANKS_LOADED, ALL_RANKS_LOADING, ALUMNI_CONTACT_INFORMATION_UPDATING, ALUMNI_CONTACT_INFORMATION_UPDATED, ALUMNI_CONTACT_INFORMATION_UPDATE_FAILED,
    PROFILE_INFO, PROFILE_INFO_LOADING, MARITAL_STATUS_LOADED, MARITAL_STATUS_LOADING, ALUMNI_ADDRESS_UPDATING, ALUMNI_ADDRESS_UPDATED, ALUMNI_ADDRESS_UPDATE_FAILED,
    QUICK_SEARCH_REQUEST, QUICK_SEARCH_RECORDS, QUICK_SEARCH_RECORDS_ROOT, MY_ADDRESS_UPDATED, MY_ADDRESS_UPDATING, MY_ADDRESS_UPDATE_FAILED,
    MY_CONTACT_INFORMATION_UPDATE_FAILED, ALUMNI_INFORMATION_UPDATE_FAILED, ALUMNI_INFORMATION_UPDATE_FAILED_BY_ADMIN,
    SAF_MEMBERSHIP_UPDATE_FAILED, NESA_MEMBERSHIP_UPDATE_FAILED,
    DOWNLOADING_CSV, DOWNLOADED_CSV, DOWNLOAD_CSV_ERROR, PUBLICATIONS, PUBLICATIONS_LOADING, MY_RANKS_LOADED, MY_RANKS_LOADING, GENDERS_RECEIVED, GENDERS_LOADING,
    ISADMIN, ISADMIN_LOADING, ISSPECIALIST, ISSUPERADMIN, GIFT_MEMBERSHIP_RESGISTRATION_LOADING, GIFT_MEMBERSHIP_RESGISTRATION, LOOKUP_SOCIALMEDIA_LOADING, LOOKUP_SOCIALMEDIA_RECEIVED,
    COMPLETE_COLUMN_LIST_LOADING, COMPLETE_COLUMN_LIST, COMPLETE_COLUMN_LIST_ERROR, PHONE_COUNTRY_CODE_LOADING, PHONE_COUNTRY_CODE,
    MY_PREFERENCE_LIST, MY_PREFERENCE_LIST_LOADING, PRIVACY_SETTINGS_LOADING, PRIVACY_SETTINGS_UPDATED, DELETE_LOCALAWARDS, DELETED_LOCALAWARDS,
    PUBLIC_PREFERENCE_LIST, PUBLIC_PREFERENCE_LIST_LOADING, ADDRESS_TYPES_LOADED, ADDRESS_TYPES_LOADING,
    QUICK_PREFERENCE_LIST_LOADING, QUICK_PREFERENCE_LIST, PREFIX_LOADING, PREFIX_RECEIVED, SUFFIX_LOADING, SUFFIX_RECEIVED,
    DASHBOARD_MY_PREFERENCE_LIST_LOADING, DASHBOARD_MY_PREFERENCE_LIST, ALUMNI_INFORMATION_UPDATING, ALUMNI_INFORMATION_UPDATED,
    DASHBOARD_QUICK_PREFERENCE_LIST_LOADING, REMOVE_QUICK_PREFERENCE_LIST, DASHBOARD_QUICK_PREFERENCE_LIST, RECEIVING_REG_STATUS, REG_STATUS_FAILED, REQUESTING_REG_STATUS,
    RUN_PREFERENCE_LIST_LOADING, RUN_PREFERENCE_LIST, RUN_PREFERENCE_LIST_FAILED, HOME_ADDRESS_RECEIVED, HOME_ADDRESS_LOADING,
    GET_PREFERENCE_DATA, GET_PREFERENCE_DATA_LOADING, ADDITIONAL_INFORMATION_UPDATED, ADDITIONAL_INFORMATION_UPDATING,
    CHASE_PAYMENT_LOADING, CHASE_PAYMENT_INIT, GIFT_MEMBERSHIP_RESGISTRATION_ERROR, WEB_CONTACT_INFORMATION_UPDATED, WEB_CONTACT_INFORMATION_UPDATING,
    UPDATE_PROFILE, UPDATE_PROFILE_LOADING, MY_CONTACT_INFORMATION_UPDATED, MY_CONTACT_INFORMATION_UPDATING,
    PERSONS_PROFILE, PERSONS_PROFILE_LOADING, RECEIVE_NOTES, MEMBERSHIP_NOTES_UPDATING, MEMBERSHIP_NOTES_UPDATED,
    GET_EVENTS, GET_EVENTS_LOADING, SAF_MEMBERSHIP_UPDATING, LOADING_LOCALAWARDS, LOADED_LOCALAWARDS, ADD_LOCALAWARDS, ADDED_LOCALAWARDS,
    MEMBERSHIP_VERFICATION_LOADING, MEMBERSHIP_VERFICATION_STATUS, ADD_ADMINREPAIR, ADDED_ADMINREPAIR, ADD_ADMINREPAIR_FAILED,
    MEMBERSHIP_RESGISTRATION, MEMBERSHIP_RESGISTRATION_LOADING,
    ROLES_LOADING, ROLES_RECEIVED, SAF_MEMBERSHIP_UPDATED,
    ETHNICITIES_LOADING, ETHNICITIES_RECEIVED, NESA_MEMBERSHIP_UPDATING,
    OCCUPATIONS_LOADING, OCCUPATIONS_RECEIVED,
    PENDING_MEMBERSHIP_LOADING, PENDING_MEMBERSHIP_RECEIVED,
    MEMBERSHIP_RECORD_LOADING, MEMBERSHIP_RECORD_RECEIVED, MEMBERSHIP_RECORD_FAILURE, MEMBERSHIP_RECORD_PAYMENT_LOADING, MEMBERSHIP_RECORD_PAYMENT_RECEIVED,
    COUNTRIES_LOADING, COUNTRIES_RECEIVED,
    STATES_LOADING, STATES_RECEIVED, LOADING_RECEIPT, LOADED_RECEIPT,
    NESA_LEVELS_LOADING, NESA_LEVELS_RECEIVED,
    PRODUCT_PRICING_LOADING, PRODUCT_PRICING_RECEIVED,
    MY_EAGLE_INFO_LOADING, MY_EAGLE_INFO_RECEIVED, NESA_MEMBERSHIP_UPDATED,
    SAF_LEVELS_LOADING, SAF_LEVELS_RECEIVED, SAF_RESGISTRATION_ERROR,
    UPDATING_ADDRESS, ADDRESS_UPDATED, SAF_REGISTRATION_LOADING, SAF_REGISTRATION_RECEIVED,
    ADVANCED_SEARCH_LIST, ADVANCED_SEARCH_LIST_LOADING, ADVANCED_SEARCH_LIST_FAILED, REMOVE_ADVANCED_SEARCH_LIST,
    ACTIVATE_MEMBERSHIP_STATUS_LOADING, ACTIVATE_MEMBERSHIP_STATUS, PENDING_MEMBERSHIP_APPLICATION_STATUS, PENDING_MEMBERSHIP_LOADING,
    DENY_MEMBERSHIP_APPLICATION_STATUS, DENY_MEMBERSHIP_APPLICATION_STATUS_LOADING,
    PAYMENT_COMPLETED, SAF_RESGISTRATION_LOADING, SAF_RESGISTRATION,
    PURCHASE_RESGISTRATION, PURCHASE_RESGISTRATION_ERROR, PURCHASE_RESGISTRATION_LOADING,
    ADD_MEMBERSHIP_RESGISTRATION, ADD_MEMBERSHIP_RESGISTRATION_ERROR, ADD_MEMBERSHIP_RESGISTRATION_LOADING,
    ALUMNI_INFO_LOADING, ALUMNI_INFO, NESA_REGISTRATION_LOADING, NESA_REGISTRATION_RECEIVED,
    NESA_NON_REVENUE_MEMBERSHIP_ADDING, NESA_NON_REVENUE_MEMBERSHIP_ADDED, NESA_NON_REVENUE_MEMBERSHIP_ADD_FAILED,
    ALUMNI_EAGLE_INFO_RECEIVED, ALUMNI_EAGLE_INFO_LOADING, ALUMNI_INFORMATION_UPDATED_BY_ADMIN, ALUMNI_INFORMATION_UPDATING_BY_ADMIN,
    DOWNLOADING_NESA_MEMBERSHIP, DOWNLOADED_NESA_MEMBERSHIP, MAXIMUM_CSVRECORDS_REACHED, MAXIMUM_CSVRECORDS_REACHED_ClOSE,
    // DOWNLOADED_NESA_PENDING_MEMBERSHIP,DOWNLOADED_NESA_PROCESSED_MEMBERSHIP,DOWNLOADED_NESA_DENIED_MEMBERSHIP,
    SENDING_SPARK_OPPORTUNITY_FORM, SUCCESSFULLY_SENT_SPARK_OPPORTUNITY_FORM, FAILED_TO_SENT_SPARK_OPPORTUNITY_FORM,
    UPDATING_COLUMN, UPDATED_COLUMN, PROMOCODE_LOADING, PROMOCODE_ERROR, PROMOCODE_APPLIED, PAYMENTS_CREATING, PAYMENTS_CREATED,
    GETTING_EAGLE_SCOUTS_SUMMARY, GET_EAGLE_SCOUTS_SUMMARY, GETTING_NESA_SUMMARY, GET_NESA_SUMMARY, GETTING_EAGLE_SCOUTS_SUMMARY_CUSTOMDATE, GET_EAGLE_SCOUTS_SUMMARY_CUSTOMDATE, GETTING_NESA_SUMMARY_CUSTOMDATE, GET_NESA_SUMMARY_CUSTOMDATE,
    REMOVE_PROMOCODE_ERROR, REMOVE_PROMOCODE_LOADING, PROMOCODE_REMOVED, SEARCH_PROMOCODE_LOADING,
    GET_PROMOCODE_LOADING, GOT_PROMOCODE_SUCCESSFULLY, GET_PROMOCODE_ERROR,
    ADD_PROMOCODE_LOADING, ADDED_PROMOCODE_SUCCESSFULLY, ADD_PROMOCODE_ERROR,
    UPDATE_PROMOCODE_LOADING, UPDATED_PROMOCODE_SUCCESSFULLY, UPDATE_PROMOCODE_ERROR,
    DELETE_PROMOCODE_LOADING, DELETED_PROMOCODE_SUCCESSFULLY, DELETE_PROMOCODE_ERROR, ADD_AFFINITIES, ADDED_AFFINITIES, DELETE_AFFINITIES, DELETED_AFFINITIES,
    GETTING_ORDER_SOURCE, GOT_ORDER_SOURCE_SUCCESSFULLY, ORDER_SOURCE_FAILED, GETTING_BSA_ORDER_TYPE, GOT_BSA_ORDER_TYPE_SUCCESSFULLY, BSA_ORDER_TYPE_FAILED,
    RECIVED_SHOPPINGCART, GETTING_SHOPPINGCART,
    DENY_TO_PENDING_MEMBERSHIP_APPLICATION_STATUS, DENY_TO_PENDING_MEMBERSHIP_APPLICATION_STATUS_LOADING, RES_OF_EXPIRE_MEMBERSHIP, REQ_TO_EXPIRE_MEMBERSHIP,
    CASH_PAYMENT_INITIATED, CASH_PAYMENT_COMPLETED,
    ADDING_MEMBERID, ADDED_MEMBERID, FAILED_TO_ADD_MEMBERID,
    DELETING_MEMBERID, DELETED_MEMBERID, FAILED_TO_DELETE_MEMBERID,
    REQUESTING_ALUMNI_PRIVACY_OPTIONS, RECEIVED_ALUMNI_PRIVACY_OPTIONS, FAILED_TO_GET_ALUMNI_PRIVACY_OPTIONS, UPDATING_ALUMNI_PRIVACY_OPTIONS, UPDATED_ALUMNI_PRIVACY_OPTIONS, FAILED_TO_UPDATE_ALUMNI_PRIVACY_OPTIONS,
    REQUESTED_TO_GET_ALUMNI_AND_LOCAL_AWARDS, RECEIVED_ALUMNI_AND_LOCAL_AWARDS, REQUESTED_TO_GET_SCOUTINGS_AFFILIATIONS, RECEIVED_SCOUTINGS_AFFILIATIONS, REQUESTED_TO_GET_COUNCIL_AFFILIATIONS, RECEIVED_COUNCIL_AFFILIATIONS, REQUESTED_TO_GET_AFFINITIES, RECEIVED_AFFINITIES, FAILED_TO_GET_ALUMNI_AND_LOCAL_AWARDS, FAILED_TO_GET_SCOUTINGS_AFFILIATIONS, FAILED_TO_GET_COUNCIL_AFFILIATIONS, FAILED_TO_GET_AFFINITIES,
    ADDING_OR_REMOVING_HOBBIES, HOBBIES_ADDED_OR_REMOVED_SUCCESSFULLY, ADDING_OR_REMOVING_BUSINESS, BUSINESS_ADDED_OR_REMOVED_SUCESSFULLY, UPDATING_EMPLOYER_DETAILS, UPDATED_EMPLOYER_DETAILS, DELETING_EMPLOYER_DETAILS, DELETED_EMPLOYER_DETAILS, DELETING_OCCUPATION_DETAILS, DELETED_OCCUPATION_DETAILS, EAGLE_NESA_MEMBERSHIPS_LOADING, EAGLE_NESA_MEMBERSHIPS_RECEIVED, EAGLE_NESA_MEMBERSHIPS_ERROR,
    ASSIGN_ROLES_POSITIONS_LOADING, ASSIGN_ROLES_POSITIONS, ASSIGN_ROLES_POSITIONS_ERROR, USER_FUNCTIONAL_ROLES_LOADING, USER_FUNCTIONAL_ROLES_RECEIVED, USER_FUNCTIONAL_ROLES_ERROR, REMOVE_USER_ROLE_LOADING, REMOVE_USER_ROLE_SUCCESS, REMOVE_USER_ROLE_ERROR, SEARCHING_GLOBAL, SEARCHED_GLOBAL, SEARCHED_GLOBAL_ERROR, ROLES_PERSONSGUID_LOADING, ROLES_PERSONSGUID_RECEIVE, ROLES_PERSONSGUID_ERROR, ADD_NEW_EAGLE_DETAILS, ADDED_NEW_EAGLE_DETAILS, FAILED_NEW_EAGLE_DETAILS,
    CHILD_ORG_LOADING, CHILD_ORG_RECEIVE, CHILD_ORG_ERROR, ORGANIZATION_POSITIONS_LOADING, ORGANIZATION_POSITIONS_RECEIVE, ORGANIZATION_POSITIONS_ERROR, ROLES_EXPIRE_LOADING, ROLES_EXPIRE_SUCCESS, ROLES_EXPIRE_ERROR,
    REQUESTED_TO_GET_COUNCIL_BY_ZIPCODE, RECEIVED_COUNCIL_BY_ZIPCODE, FAILED_TO_GET_COUNCIL_BY_ZIPCODE, GET_PREFERENCE_DATA_FAILURE, ADVANCED_RECORDS_LOADING_START, ADVANCED_RECORDS_LOADING_STOP,
    ALUMNI_RECORDS_LOADING_START, ALUMNI_RECORDS_LOADING_STOP, QUICK_RECORDS_LOADING_START, QUICK_RECORDS_LOADING_STOP,
    SHOW_ABOUT_TO_EXPIRE, HIDE_ABOUT_TO_EXPIRE, GET_RANKS_LOADING, GET_RANKS_RECEIVE, GET_RANKS_ERROR, UPDATE_RANK_LOADING, UPDATE_RANK_SUCCESS, UPDATE_RANK_ERROR, DELETE_RANK_LOADING, DELETE_RANK_SUCCESS, DELETE_RANK_ERROR,
    GET_LOOKUPS_RANKS_LOADING, GET_LOOKUPS__RANKS_RECEIVE, GET_LOOKUPS_RANKS_ERROR, 
    COUNTRIES_FAILED, PHONE_COUNTRY_CODE_FAILED, STATES_FAILED, NESA_LEVELS_FAILED, PRODUCT_PRICING_FAILED,
    GETTING_ACTIVE_REGISTRATIONS_FOR_EXTEND_ROLE, RECEIVED_ACTIVE_REGISTRATIONS_FOR_EXTEND_ROLE, FAILED_ACTIVE_REGISTRATIONS_FOR_EXTEND_ROLE, ADD_PERSON_REQUEST, ADD_PERSON_SUCCESS, ADD_PERSON_ERROR, GET_COMMUNITY_LOADING, GET_COMMUNITY_RECEIVE, GET_COMMUNITY_ERROR, FAILED_TO_GET_COMMUNITY_ERROR,
    REQUESTED_TO_GET_RANKS_BY_USERNAME, RECEIVED_RANKS_BY_USERNAME, FAILED_TO_GET_RANKS_BY_USERNAME,
    GET_COMMUNITY_LOOKUP_LOADING, GET_COMMUNITY_LOOKUP_SUCCESS, GET_COMMUNITY_LOOKUP_ERROR,
    ALUMNI_LOOKUP_LOADING, ALUMNI_LOOKUP_SUCCESS, ALUMNI_LOOKUP_ERROR,
    REQ_TO_GET_REPORT_COLUMN, RECEIVED_GET_REPORT_COLUMN,
    LOADING_NATIONAL_AWARDS, LOADED_NATIONAL_AWARDS,
}


// WEBPACK FOOTER //
// ./src/actions/ActionTypes.js